module.exports = __webpack_public_path__ + "img/liveIcon13.8f87fdb7.png";